import { IoClose } from "react-icons/io5";
import React from "react";

export default function ChatWindow({
  children,
  title,
  customClass,
  onClose,
  onAnimationEnd,
}) {
  return (
    <div
      className={`flex fixed bottom-0 left-0 z-50 flex-col w-full h-3/5 bg-altgray-50 ${customClass}`}
      onAnimationEnd={onAnimationEnd}
    >
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-5 right-5 btn btn-icon btn-icon-md btn-goast"
        >
          <div className="text-2xl">
            <IoClose />
          </div>
        </button>
      )}
      <div className="p-6 text-xl font-semibold bg-white border-b md:text-2xl border-b-altgray-200">
        {title}
      </div>
      {children}
    </div>
  );
}
